import { render } from "./AppDashStat.vue?vue&type=template&id=5343c514&scoped=true"
import script from "./AppDashStat.vue?vue&type=script&lang=js"
export * from "./AppDashStat.vue?vue&type=script&lang=js"

import "./AppDashStat.vue?vue&type=style&index=0&id=5343c514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5343c514"]])

export default __exports__